import { ManageChannelsScreen } from "open-modules/zdf/feature/admin/admin-manage-channels";
import { CLICK, POPUP } from "system/demo";
import { channelManagementDemoData, demoAdminEmails } from "./channeldemo.data";

export function adminManageChannelsStorySets() {
    return [
        {
            label: "Manage channel",
            instanceKey: "a",
            personaKey: "a",
            serverCall: channelManagementDemoData.serverCall,
            modulePublic: channelManagementDemoData.modulePublic,
            sessionData: { channelMembers: channelManagementDemoData.channelMembers },
            roles: ["Owner"],
            content: <ManageChannelsScreen />,
            stories: [
                {
                    label: "Delete user from channel",
                    actions: [
                        CLICK("selectable-tile-" + channelManagementDemoData.modulePublic.channel.all.channel0.key),
                        CLICK("delete-member-" + channelManagementDemoData.channelMembers.channel0.memberEmails[0]),
                    ],
                },
                {
                    label: "Add user to channel",
                    actions: [
                        CLICK("selectable-tile-" + channelManagementDemoData.modulePublic.channel.all.channel1.key),
                        CLICK("add-member-dropdown"),
                        POPUP(CLICK(demoAdminEmails[2])),
                        CLICK("Add Moderator"),
                    ],
                },
            ],
        },
    ];
}
